/**
 * Libs
 */
import React from 'react';

/**
 * Components
 */
import { Typography } from 'src/ui/common/atoms/typography';

/**
 * Styles
 */
import { StyledFaqSection } from '../../containers/faq-container.styles';

interface IProperties {
    title: string;
    anchor: string;
}

export const FaqPageSection: React.FC<IProperties> = ({ children, title, anchor }) => (
    <StyledFaqSection id={anchor} data-observablesection>
        <Typography variant='title' size='lg' tag='h2'>{title}</Typography>
        {children}
    </StyledFaqSection>
);
